/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Date_PlaceholderInputs */

const en_search_date_placeholder = /** @type {(inputs: Search_Date_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search date...`)
};

const es_search_date_placeholder = /** @type {(inputs: Search_Date_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar fecha...`)
};

/**
* | output |
* | --- |
* | "Search date..." |
*
* @param {Search_Date_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_date_placeholder = /** @type {((inputs?: Search_Date_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Date_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_date_placeholder(inputs)
	return es_search_date_placeholder(inputs)
});